import { db } from '../App';
import { doc, getDoc, updateDoc, increment, collection, query, where, getDocs, deleteDoc } from "firebase/firestore";

export const fetchFriendData = async (friendId) => {
  if (friendId) {
    const friendDoc = await getDoc(doc(db, 'users', friendId));
    if (friendDoc.exists()) {
      return { id: friendDoc.id, ...friendDoc.data() };
    } else {
      throw new Error('Friend not found');
    }
  }
  throw new Error('No friend ID provided');
};

export const removeFriend = async (currentUserId, friendId) => {
  try {
    const currentUserFriendRef = query(collection(db, 'users', currentUserId, 'friends'), where('friendId', '==', friendId));
    const friendUserFriendRef = query(collection(db, 'users', friendId, 'friends'), where('friendId', '==', currentUserId));

    const currentUserFriendSnapshot = await getDocs(currentUserFriendRef);
    const friendUserFriendSnapshot = await getDocs(friendUserFriendRef);

    currentUserFriendSnapshot.forEach(async (doc) => {
      await deleteDoc(doc.ref);
    });

    friendUserFriendSnapshot.forEach(async (doc) => {
      await deleteDoc(doc.ref);
    });

    console.log(`Removed friend relationship between ${currentUserId} and ${friendId}`);
  } catch (error) {
    console.error('Error removing friend:', error);
  }
};

export const sendTip = async (userId, friendId, amount) => {
  if (isNaN(amount) || amount <= 0) {
    throw new Error('Invalid tip amount');
  }

  const userRef = doc(db, 'users', userId);
  const friendRef = doc(db, 'users', friendId);

  try {
    const userDoc = await getDoc(userRef);
    if (!userDoc.exists()) {
      throw new Error('User document not found');
    }

    const userData = userDoc.data();
    const userBalance = userData.money || 0;

    if (userBalance < amount) {
      throw new Error('Insufficient funds');
    }

    await updateDoc(userRef, {
      money: increment(-amount)
    });

    await updateDoc(friendRef, {
      money: increment(amount)
    });

    console.log(`Transferred ${amount} from ${userId} to ${friendId}`);
  } catch (error) {
    console.error('Error in sendTip:', error);
    throw error;
  }
};